import SepaPaymentTerms from './SepaPaymentTerms';

export default SepaPaymentTerms;
